module.exports = __webpack_public_path__ + "img/background.62b680db.svg";